import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSubscriptionRoutesConditions } from '@pages/Subscriptions/SubscriptionsRoutes'

import { CartIcon } from '@icons/CartIcon'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection } from '../useMenuSections'

export const useSubscriptionsMenu = (): MenuSection => {
  const { t } = useTranslation()
  const { isSubscriptionsVisible } = useSubscriptionRoutesConditions()

  return useMemo(
    () => ({
      id: 'subscriptions',
      label: t('Tabs.Subscriptions'),
      icon: CartIcon,
      condition: isSubscriptionsVisible,
      products: [TickmillProductType.ETD],
      children: [
        {
          id: 'trading-platforms',
          label: t('Subscriptions.Trading Platforms'),
          path: '/dashboard/subscriptions/trading-platforms',
        },
        {
          id: 'market-data',
          label: t('Market Data.title'),
          path: '/dashboard/subscriptions/market-data',
        },
        {
          id: 'history',
          label: t('History'),
          path: '/dashboard/subscriptions/history',
        },
      ],
    }),
    [t, isSubscriptionsVisible]
  )
}
